import React, { useEffect, useState } from "react";
import ProjectCard from "./ProjectCard";

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("https://portfolio-farhan-hasin-dipro-v2-server.vercel.app/projects")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <div className="bg-primary lg:pb-56 md:pb-56 sm:pb-20 pb-20">
      <div className="container mx-auto">
        <h2 className="text-accent lg:text-start md:text-center sm:text-center text-center lg:text-7xl md:text-5xl sm:text-3xl text-3xl ,md:pb-20 sm:pb-8 pb-8 font-semibold hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
          CODING PROJECTS
        </h2>
        <div>
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project}></ProjectCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
